import { useCallback } from "react";
import { useUi } from "application/contexts/ui/UIContext";
import { ErrorCodeType } from "application/models/IError";
import { Kiosk } from "domains/kiosk/aggregates/Kiosk";
import { InventoryRepository } from "Infrastructure/repositories/api/InventoryRepository";
import { ValidateInventoryUseCase } from "modules/order/application/useCases/ValidateInventoryUseCase";
import { IOrder } from "modules/order/domain/models/IOrder";
import { GetError } from "utils/GetError";

export const useValidateInventory = () => {
  const { showLoading, hideLoading, toastFullscreen } = useUi();

  const validateInventory = useCallback(
    async (order: IOrder, kiosk: Kiosk): Promise<void> => {
      if (!kiosk?.verifyInventory) {
        return;
      }

      showLoading();
      try {
        const inventoryRepository = InventoryRepository();
        const result = await ValidateInventoryUseCase(
          inventoryRepository,
          order,
          kiosk
        );

        if (!result.success) {
          if (kiosk.blockOrderIfEmptyInvetory) {
            throw GetError(
              new Error(result.message),
              "validateInventory",
              "useValidateInventory",
              result.message,
              ErrorCodeType.ORDER
            );
          }
          toastFullscreen(result.message ?? "", "warning", { time: 4000 });
        }
      } finally {
        hideLoading();
      }
    },
    [showLoading, hideLoading, toastFullscreen]
  );

  return { validateInventory };
};
